


























import {FoundVacancies, FoundVacanciesFilter} from "@/model/find-vacancies-response";
import {VacancyListFilter} from "@/model/vacancy-list-filter";
import Vue from "vue";
import VacancySelectFilter from "@/components/vacancy-search/filters/SelectFilter.vue";

export default Vue.extend({
  name: "VacancyFilters",
  components: {
    VacancySelectFilter,
  },
  data() {
    return <{
      filterableFilters: Array<string>
      showSecondaryFilters: boolean
    }>{
      filterableFilters: ["discipline", "organizationalUnit", "branch", "location"],
      showSecondaryFilters: false
    };
  },
  props: {
    activeFilter: {
      type: Object as () => VacancyListFilter,
      required: true
    },
    foundVacancies: {
      type: Object as () => FoundVacancies,
      required: true
    },
  },
  mounted() {
  },
  computed: {
    primaryFilters(): FoundVacanciesFilter[] {
      if (this.foundVacancies == null) return [];

      const filters = this.filterableFilters.slice(0, 4)
          .map(filterName => {
            if (this.foundVacancies.filters[filterName] == null) {
              console.warn("Primary filters not found for key", filterName);
            }
            return this.foundVacancies.filters[filterName];
          })
          .filter(filters => filters != null);

      return filters;
    },
  },
  methods: {
    isRangeFilter(filterName: string) {
      return false;
    },
    toggleShowMoreFilters() {
      this.showSecondaryFilters = !this.showSecondaryFilters;
      // console.log('DIVS: ' + Array.prototype.slice.call(document.getElementsByTagName("main")))
      document.getElementsByTagName("main")[0].classList.toggle("filters-shown");
    }

  }
});
